import * as React from 'react';

// ─── Component ────────────────────────────────────────────────────────────────

export function HetivoIcon(): React.JSX.Element {
  return (
    <div className="flex h-4 w-4 items-center justify-center rounded-full bg-primary shrink-0">
      <span className="text-[10px] font-bold text-primary-foreground">H</span>
    </div>
  );
}
